import translations from './translations';

const Localization = {
  store: undefined,
  // The install method is all that needs to exist on the plugin object.
  // It takes the global Vue object as well as user-defined options.
  install(Vue, options) {
    Vue.prototype.elementUILang = options.locale;
    Vue.prototype.elementUILangEN = JSON.parse(JSON.stringify(options.EN));
    Vue.prototype.elementUILangAT = JSON.parse(JSON.stringify(options.AT));
    Vue.prototype.elementUILangDE = JSON.parse(JSON.stringify(options.DE));
    Vue.prototype.elementUILangFR = JSON.parse(JSON.stringify(options.FR));
    Vue.prototype.elementUILangSL = JSON.parse(JSON.stringify(options.SL));


    Vue.prototype.$switch = function(lang){
        if(lang == 'en'){
          this.elementUILang.el.datepicker = this.elementUILangEN.el.datepicker;
        }
        else if(lang == 'at'){
          this.elementUILang.el.datepicker = this.elementUILangDE.el.datepicker;
        }
        else if(lang == 'de'){
          this.elementUILang.el.datepicker = this.elementUILangDE.el.datepicker;
        }
        else if(lang == 'fr'){
          this.elementUILang.el.datepicker = this.elementUILangFR.el.datepicker;
        }
        else if(lang == 'sl'){
          this.elementUILang.el.datepicker = this.elementUILangSL.el.datepicker;
        }
    }
    

    Vue.prototype.$l = function(input, lang, capital){
      if(!lang)
        lang = 'en'


      try{
        lang = this.$store.getters.getLocalSettings.interface.language;
      }catch(err){lang = 'en'}

      var output = getWord(input, lang);
      
      if(capital){
        return output.toUpperCase();

      }
      return output;
    }

    Vue.prototype.$localSupport = function(type){
        if(type == '') return '';
        var lang = this.$store.getters.getLang;
        lang = lang+'Support';
        return getWord(type, lang);
    }

    function getWord(input, lang){
      var sections = input.split('/');
      var word = translations[lang];
      try{
        sections.forEach((section)=>{
          word = word[section];
        })
      }catch(e){
        word = undefined;
      }finally{
        if(word)
          return word;
        else{
          console.log(input+" missing translation");
          return "N_T "+input;

        }
      }
      
    }
  },
  getTranslations(){
      return translations;
  }
};



export default Localization;


// WEBPACK FOOTER //
// ./src/localization/index.js